import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {action, observable} from 'mobx';
import {withStyles} from '@material-ui/core/styles';
import Close from 'react-icons/lib/md/close';
import {DialogTypes, ProjectType} from '../../../constants/enums';
import LessonInfoEditor from './LessonInfoEditor';
import './lessonInfo.scss';
import DialogWrapper from '../../../components/dialog/Dialog';

const styles = () => ({
    dialog: {
        zIndex: 1400
    },
    paper: {
        boxShadow: 'none',
        width: 1000,
        maxWidth: 'calc(100vw - 48px)',
        overflow: 'hidden',
        display: 'block',
        borderRadius: '16px 16px 0 0',
        maxHeight: 'calc(100% - 28px)',
        margin: 0,
        background: 'none'
    }
});

@inject('projectStore', 'dialogStore')
@observer
class LessonInfoDialogContainer extends Component {
    @observable isSaveProcessing = false;
    @observable processing = {
        status: false,
        percent: 0
    };

    @action setUploadStatus = (val) => {
        this.processing.status = val;
    }

    @action setUploadPercent = (val) => {
        this.processing.percent = val;
    }

    @action closeInfoDialog = () => {
        const {dialogStore, projectStore} = this.props;
        if (this.isSaveProcessing) return;
        if (projectStore.isLessonEditing) {
            projectStore.finishEditLesson();
        }
        if (projectStore.activeProject && projectStore.activeProject.type === ProjectType.Global) {
            projectStore.clearPlayer(projectStore.activeProject);
            projectStore.clearActiveProject();
        }
        projectStore.stopAll();
        projectStore.editedLesson = null;
        dialogStore.closeDialog(DialogTypes.LessonInfo);
    };

    render() {
        const {dialogStore, classes} = this.props;

        return (
            <DialogWrapper className="dialog-window" classes={{root: classes.dialog, paper: classes.paper}}
                open={dialogStore.getDialogState(DialogTypes.LessonInfo)} onClose={this.closeInfoDialog}>
                <button className="lesson-dialog-close" onClick={this.closeInfoDialog} disabled={this.isSaveProcessing}>
                    <Close style={{fontSize: 26}}/>
                </button>
                <LessonInfoEditor uploadStatus={this.processing.status} uploadPercent={this.processing.percent}
                                  onUploadStatusChange={this.setUploadStatus} onUploadPercentChange={this.setUploadPercent}/>
            </DialogWrapper>
        );
    }
}

export default withStyles(styles)(LessonInfoDialogContainer);
